import React from "react";
import PropTypes from "prop-types";
import BaseMenu from "./base-menu";
import MenuItem from "./menu-item";

function CategoryMenu({ selectedProductType, selectedProductTypeData, onCategoryClick }) {
    return (
        <BaseMenu>
            {selectedProductType ? (
                <ul>
                    {selectedProductTypeData.categories.map((category, index) => {
                        const categoryName = category.name;

                        return (
                            <MenuItem
                                value={categoryName}
                                key={index}
                                onClick={() => onCategoryClick(categoryName)}
                            />
                        );
                    })}
                </ul>
            ) : null}
        </BaseMenu>
    );
}

export default CategoryMenu;

CategoryMenu.propTypes = {
    selectedProductType: PropTypes.string,
    selectedProductTypeData: PropTypes.object,
    onCategoryClick: PropTypes.func.isRequired
};

CategoryMenu.defaultProps = {
    selectedProductType: null,
    // when selectedProductType is null
    selectedProductTypeData: undefined
};
